import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Card } from "@/components/ui/card";
import ModelTab from "./ModelTab";
import TranscriberTab from "./TranscriberTab";
import VoiceTab from "./VoiceTab";

export default function AgentTab() {
  return (
    <Card className="border-none shadow-none">
      <Accordion type="single" collapsible className="w-full space-y-4">
        <AccordionItem value="model" className="border rounded-lg">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">Model Configuration</h3>
              <p className="text-sm text-muted-foreground">
                Configure the language model and basic settings for your
                assistant
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <ModelTab />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="stt_provider" className="border rounded-lg">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">
                Transcriber Configuration
              </h3>
              <p className="text-sm text-muted-foreground">
                Configure speech-to-text capabilities for your assistant using
                providers like OpenAI, Deepgram, Groq, and more
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <TranscriberTab />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="voice" className="border rounded-lg">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">Voice Configuration</h3>
              <p className="text-sm text-muted-foreground">
                Configure ElevenLabs text-to-speech capabilities for your
                assistant
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <VoiceTab />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </Card>
  );
}
